<template>
  <div style="border-style: solid; border-width: 1px; width: 100%; height: 100%; padding: 4px">
    <!-- Título da Guia -->

    <div class="row">
      <div class="col d-flex justify-content-between">
        <img
          class="text-left"
          :src="logo"
          alt="logo_operadora"
          width="100mm"
          height="60mm"
          v-if="logo"
        />
        <div style="min-width: 100px;" v-else>{{ operadora }}</div>
        <div
          class="text-center align-item-center px-3"
          style="font-size:14px; font-weight:700;"
        >{{ title }}</div>
        <div class="text-right" style="min-width: 200px;">
          <span
            v-if="guiaPrestador"
            class="mr-1 font-weight-bold"
            style="font-size: 8pt; "
          >2- No. Guia do Prestador:</span>
          <span v-if="guiaPrestador" style="font-size: 11pt; ">{{ guiaPrestador }}</span>
        </div>
      </div>
    </div>

    <!-- Corpo da Guia -->

    <div class="row">
      <div class="col">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    tstyle: function() {
      return this.largura ? { width: this.largura } : {};
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    guiaPrestador: {
      type: String,
      default: ""
    },
    largura: {
      type: String,
      default: "18cm"
    },
    logo: {
      type: String,
      default: ""
    },
    operadora: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.contorno-guia {
  border-style: solid;
  border-width: 1px;
}
</style>
